module.exports = __webpack_public_path__ + "static/img/schedule-logo.cc80176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schedule-logo.png
// module id = 0MiS
// module chunks = 1